<template>
  <div class="Page">
    <div v-if="this.current">
      <!--Banner-->
      <section class="">
          <div class="banner" :style="this.dealerSelected.detailed.banner ? { backgroundImage: 'url(' + this.dealerSelected.detailed.banner + ')' } : {}">
              <h1 class="PageTitle" v-html="this.current.title"></h1>
          </div>
          <div class="orangeStripe"></div>
      </section>
      <!--info-->
      <section class="">
        <v-row v-if="this.dealerSelected">
          <v-col cols="12" md="6" class="infoSection">
              <v-row><v-col><h2 class="infoTitle">Emplacement</h2> </v-col></v-row>
              <v-row class="textSection">
                <v-col v-if="this.dealerSelected" cols="12" >
                  <v-row class="infoRow">
                      <v-col class="d-flex align-center"><p v-html="this.dealerSelected.name"></p></v-col>
                  </v-row>
                </v-col>
                <v-col v-if="this.dealerSelected.address" cols="12" >
                  <v-row class="infoRow">
                      <v-col cols="1"><img src="/ressources/images/icon/jobMapIcon.png" /></v-col>
                      <v-col class="d-flex align-center"><p v-html="this.dealerSelected.address"></p></v-col>
                  </v-row>
                </v-col>
              </v-row>
          </v-col>
          <v-col cols="12" md="6" style="padding: 0px;">
              <v-row>
                  <v-col class="containerImg">
                    <img v-if="this.dealerSelected.jobImg" :src="this.dealerSelected.jobImg" :truesrc="this.dealerSelected.jobImg" title="image Emplacement concessionnaires" alt="image Emplacement concessionnaires"/>
                    <img v-else :src="this.dealerSelected.detailed.hoursBanner" :truesrc="this.dealerSelected.detailed.hoursBanner" title="image Emplacement concessionnaires" alt="image Emplacement concessionnaires"/>
                  </v-col>
              </v-row>
          </v-col>
        </v-row>
      </section>
      <!--Requirements-->
      <section class="">
        <v-row>
          <v-col cols="12" md="6" class="requireSection">
              <v-row style="">
                <v-row><v-col><h2 class="requireTitle">EXIGENCES ET CONDITIONS</h2> </v-col></v-row>
                <v-row >
                  <v-col v-if="this.current.fonctions" cols="12" >
                      <v-row class="infoRow">
                          <v-col cols="1"><img src="/ressources/images/career/job/arrow.svg" title="image d'une flèche" alt="image d'une flèche"/></v-col>
                          <v-col class="d-flex align-center"><p v-html="this.current.fonctions"></p></v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="this.current.statusJob" cols="12" >
                      <v-row class="infoRow">
                          <v-col cols="1"><img src="/ressources/images/career/job/arrow.svg" title="image d'une flèche" alt="image d'une flèche"/></v-col>
                          <v-col class="d-flex align-center"><p v-html="this.current.statusJob"></p></v-col>
                      </v-row>
                  </v-col>
                    <v-col v-if="this.current.workingHour" cols="12" >
                      <v-row class="infoRow">
                          <v-col cols="1"><img src="/ressources/images/career/job/arrow.svg" title="image d'une flèche" alt="image d'une flèche"/></v-col>
                          <v-col class="d-flex align-center"><p>Heures/semaine: </p><p v-html="this.current.workingHour"></p></v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="this.current.salary" cols="12" >
                      <v-row class="infoRow">
                          <v-col cols="1"><img src="/ressources/images/career/job/arrow.svg" title="image d'une flèche" alt="image d'une flèche"/></v-col>
                          <v-col class="d-flex align-center"><p>Salaire: </p><p v-html="this.current.salary"></p></v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="this.current.startJob" cols="12" >
                      <v-row class="infoRow">
                          <v-col cols="1"><img src="/ressources/images/career/job/arrow.svg" title="image d'une flèche" alt="image d'une flèche"/></v-col>
                          <v-col class="d-flex align-center"><p>Date de début: </p> <p v-html="this.current.startJob"></p></v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="this.current.yearsExperience" cols="12" >
                      <v-row class="infoRow">
                          <v-col cols="1"><img src="/ressources/images/career/job/arrow.svg" title="image d'une flèche" alt="image d'une flèche"/></v-col>
                          <v-col class="d-flex align-center"><p v-html="this.current.yearsExperience"></p></v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="this.current.spokenLanguages" cols="12">
                      <v-row class="infoRow">
                          <v-col cols="1"><img src="/ressources/images/career/job/arrow.svg" title="image d'une flèche" alt="image d'une flèche"/></v-col>
                          <v-col class="d-flex align-center"><p v-html="this.current.spokenLanguages"></p></v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="this.current.writtenLanguages" cols="12">
                      <v-row class="infoRow">
                          <v-col cols="1"><img src="/ressources/images/career/job/arrow.svg" title="image d'une flèche" alt="image d'une flèche"/></v-col>
                          <v-col class="d-flex align-center"><p v-html="this.current.writtenLanguages"></p></v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="this.current.skillsDescription" cols="12">
                      <v-row class="infoRow">
                          <v-col cols="1"><img src="/ressources/images/career/job/arrow.svg" title="image d'une flèche" alt="image d'une flèche"/></v-col>
                          <v-col class="d-flex align-center"><p v-html="this.current.skillsDescription"></p></v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="this.current.levelStudy" cols="12">
                      <v-row class="infoRow">
                          <v-col cols="1"><img src="/ressources/images/career/job/arrow.svg" title="image d'une flèche" alt="image d'une flèche"/></v-col>
                          <v-col class="d-flex align-center"><p v-html="this.current.levelStudy"></p></v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="this.current.otherRequirement" cols="12">
                      <v-row class="infoRow">
                          <v-col cols="1"><img src="/ressources/images/career/job/arrow.svg" title="image d'une flèche" alt="image d'une flèche"/></v-col>
                          <v-col class="d-flex align-center"><p v-html="this.current.otherRequirement"></p></v-col>
                      </v-row>
                  </v-col>
                </v-row>
              </v-row>

          </v-col>
          <v-col cols="12" md="6" class="requireSection">
              <v-row style="">
                <v-row><v-col><h2 class="requireTitle">Contact</h2> </v-col></v-row>
                <v-row >
                  <v-col v-if="this.current.contactName" cols="12" >
                      <v-row class="infoRow">
                          <v-col class="d-flex align-center"><p v-html="this.current.contactName"></p></v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="this.current.contactTitle" cols="12" >
                      <v-row class="infoRow">
                          <v-col class="d-flex align-center"><p style="margin-top:-15px; margin-left:10px; font-size:18px;" v-html="this.current.contactTitle"></p></v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="this.current.contactPhone" cols="12">
                      <v-row class="infoRow">
                          <v-col class="d-flex align-center"><a :href="'tel:+' + this.current.contactPhone" v-html="this.current.contactPhone"></a></v-col>
                      </v-row>
                  </v-col>
                  <v-col v-if="this.current.contactEmail" cols="12">
                      <v-row class="infoRow">
                          <v-col class="d-flex align-center"><a :href="'mailto:' + this.current.contactEmail" v-html="this.current.contactEmail"></a></v-col>
                      </v-row>
                  </v-col>
                </v-row>
              </v-row>

          </v-col>
        </v-row>
      </section>
      <!--apply-->
      <section id="apply">
        <v-row>
            <v-col cols="12" md="6" style="padding: 0px;">
                <v-row>
                    <v-col class="containerImg">
                        <div class="blackOverlay" style=""></div>
                        <img style="height: 100%; width: 100%; object-fit: cover; object-position: center;" src="../../public/ressources/images/career/job/applyImg.jpg" title="image section DEVIENS NOTRE FUTUR(E) STAGIAIRE" alt="image section DEVIENS NOTRE FUTUR(E) STAGIAIRE"/>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" md="6" style="padding: 0px;">
                <div class="applyBG">
                    <div class="applyAlignText">
                        <v-row><v-col><h2 class="sectionTitle applyTitle">QU’ATTENDS-TU ?</h2></v-col></v-row>
                        <v-row class="mt-10">
                          <v-col>
                            <router-link :to="GetPath(this.current.id)"><button class="priBtn"><h2>POSTULE DÈS MAINTENANT</h2></button></router-link>
                            <a href="https://app.cyberimpact.com/clients/47814/subscribe-forms/8F9576B8-21A3-49D4-9B9C-DA19428BAE27" target="_Blank" ><button class="priBtn mt-10"><h2>ABONNE-TOI À L’INFOLETTRE CARRIÈRE</h2></button></a> 
                          </v-col>
                        </v-row>
                    </div>
                </div>
            </v-col>
        </v-row>
      </section>
    </div>
    <div  v-if="!this.current">
        <v-row class="titleBg">
            <v-row class="bgCharging">
                <v-col><h1 class="titleCharging txt-c">La fiche de travail est en chargement <v-progress-circular style="color: rgb(var(--primary));" :size="75" :width="8" indeterminate></v-progress-circular></h1> 
                </v-col>
            </v-row>

        </v-row>
    </div>
  </div>
</template>
<style scoped>
    .v-row { width: 100%; }
    .PageTitle { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); text-align: center; z-index: 100; }
    .banner { position: relative; height: 400px; background-image: url('../../public/ressources/images/sales/banner.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; overflow: hidden; }
    .titleCharging { position: absolute; top:50%; left: 50%; transform: translate(-50%,-50%); font-family: TxtOffBDI; color: black; font-size: 36px; text-transform: uppercase;}
    .bgCharging { min-height: 700px; background-image: url('../../public/ressources/images/background-truck.jpg'); background-position: center center; background-size: cover; }
    /*#region info*/
      .containerImg { height: 400px; padding: 0px; overflow: hidden; display: flex; align-items: center; justify-content: center; }
      .containerImg img {  object-fit: cover; object-position: center center; }
      .infoSection { background-color: rgb(var(--ligthGray)); padding: 50px ; }
      .infoTitle { color: rgb(var(--secondary)); text-transform: uppercase; font-size: 32px; font-family: TxtOffBDI;  }
      .textSection { margin-top: 50px !important; }
      .textSection p { font-family: TxtOffRe;  font-size: 28px; padding-left: 20px;}
      .textSection a { font-family: TxtOffRe;  font-size: 28px; padding-left: 20px;}
      .textSection img { width: 60px; }
      .infoRow { padding: 5px 0px; }
    /*#endregion*/
    /*#region require*/
      .containerRequireImg { height: 600px; padding: 0px; overflow: hidden; display: flex; align-items: center; justify-content: center; }
      .containerRequireImg img { width: 100%; height: 100%; object-fit: cover; object-position: center center; }
      .requireSection {  background-color: rgb(var(--gray)); padding: 50px !important; position: relative; }
      .requireTitle { color: rgb(var(--secondary)); text-transform: uppercase; font-size: 32px; font-family: TxtOffBDI; margin-bottom: 30px; }
      .requireText { color: rgb(var(--white)); font-family: TxtOffRe;  font-size: 28px; font-weight: 700; padding: 20px 20%; text-align: center; }
      .requireSection p { font-family: TxtOffRe;  color: rgb(var(--white));  font-size: 28px; padding-left: 20px;}
      .requireSection a { font-family: TxtOffRe;  color: rgb(var(--white));  font-size: 28px; padding-left: 20px;}
      .requireSection a:hover { color: rgb(var(--primary)); }
      .requireSection img { width: 30px; margin-left: 20px;}
    /*#endregion*/
    /*#region apply*/
      .applyBG { position: relative; width: 100%; background-color: black; padding: 0px 50px; height: 100%; }
      .applyAlignText { position: relative; top:50%; left: 50%; transform: translate(-50%,-50%);}
      .applyTitle { color: white; font-family: TxtOffBDI; text-transform: uppercase;  }
      .applyText { font-family: TxtOffRe; margin-top: 20px;  }
    /*#endregion*/
    @media handheld, only screen and (max-width: 600px) {}
    @media handheld, only screen and (max-width: 960px) {
    h1 { font-size: 18px; }
    .infoSection { background-color: rgb(var(--ligthGray)); padding: 5px ; }
    .requireSection {  padding: 5px !important; }
    .requireSection p { font-size: 18px; }
    .requireSection a { font-size: 18px; }
    .textSection p { font-size: 18px; }
    .textSection a { font-size: 18px; }
    }
    @media handheld, only screen and (max-width: 1279px) {}
    @media handheld, only screen and (max-width: 1378px) {}
</style>
<script>

export default {
  name: 'job',
  data:()=>({
    current:null,
    errorMessage:null,
    dealerSelected: null,
    dealers:null,
  }),
  async mounted() {
    await this.dealersJsonRead();
    if(this.dealers) { this.dealers = await this.normalizeKeysToLower(this.dealers); }

    let jobkey = this.$route.params.emp;
    this.readData(jobkey);
  },
  methods:{
    dealersJsonRead: async function () {
        try {
            const response = await fetch('/ressources/json/dealers.json');
            if (!response.ok) {
                throw new Error('Failed to fetch');
            }
            this.dealers = await response.json();
        } catch (error) {
            console.error('Error loading JSON data:', error);
        }
    },
    readData: async function(jobSelected){
      let api = 'https://reseaudynamique.com/ressources/api/jobs.php?id=';
      api = api + jobSelected;
      try {
          const response = await fetch(api);
          if (!response.ok) {
              throw new Error('Failed to fetch');
          }
          this.current = await response.json();
          this.current = this.current[0];
          if(this.current) { this.feedDealer(this.current.branch); }
      } catch (error) {
          console.error('Error loading JSON data:', error);
      }
    },
    feedDealer: function(dealer) {
      if(dealer) {
        try {
          dealer = dealer.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
          if(dealer) { this.dealerSelected = this.dealers[dealer]; }
        } 
        catch (error) { this.dealerSelected = {"branch" : this.dealerSelected}; this.errorMessage = "Une erreur c'est produite dans la fiche technique"; }
        
      } else {
        this.dealerSelected = null;
      }
    },
    normalizeKeysToLower: async function(data){
        return Object.fromEntries(
          Object.entries(data).map(([k, v]) => [k.toLowerCase(), v])
        )
    },
    GetPath: function(id){
        let URL = "/postuler/";
        URL = URL + id;
        return URL;
    }
  },
  components: { }
}
</script>
